<template>
  <div class="flex flex-col" :class="size">
    <slot name="label">
      <label :for="props.name" :class="props.labelClasses">{{ label }}</label>
    </slot>
    <DatePicker
      v-model="value"
      manualInput
      showIcon
      :show-button-bar
      icon-display="button"
      inputId="modelField"
      class="h-10"
      inputClass="w-36"
      panelClass="bg-white dark:bg-surface-700/80 backdrop-blur-xl"
      :maxDate="props.maxDate"
      :show-on-focus="false"
      :disabled="disabled"
      @date-select="onSelect()"
    />
  </div>
</template>

<script setup lang="ts">
const value = defineModel<Date>({ required: true });

interface Props {
  name: string;
  label: string;
  value?: Date;
  maxDate?: Date;
  labelClasses?: string;
  disabled?: boolean;
  onSelect?: Function;
  size?: string;
  showButtonBar?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  value: () => new Date(),
  maxDate: () => new Date(),
  labelClasses: "font-bold",
  disabled: false,
  size: "w-full",
  showButtonBar: true,
});

const onSelect = (): void => {
  if (props.onSelect != null) props.onSelect();
};
</script>
